export default "__VITE_ASSET__97c537ed__"